import { useEffect, useRef } from 'react';
import type { BulkOpsAnalyticsControllerContext } from '@atlassian/jira-bulk-operations-analytics/src/controllers/types.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { AnalyticsAttributesUntyped } from '@atlassian/jira-product-analytics-bridge/src/types';

export const useFlagAnalytics = (
	attributes: AnalyticsAttributesUntyped,
	bulkOpsFlow: BulkOpsAnalyticsControllerContext,
) => {
	const analyticsEventFired = useRef(false);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		if (!analyticsEventFired.current) {
			const analyticsEvent = createAnalyticsEvent({
				actionSubject: 'bulkProcess',
				action: 'complete',
			});

			const actionSubjectId = bulkOpsFlow?.bulkOperationType;
			const analyticsAttributes = {
				...attributes,
				bulkOpsSessionID: bulkOpsFlow?.sessionID,
			};
			if (actionSubjectId) {
				fireUIAnalytics(analyticsEvent, actionSubjectId, analyticsAttributes);
			} else {
				fireUIAnalytics(analyticsEvent, analyticsAttributes);
			}
			bulkOpsFlow?.setBulkOperationType(undefined);
			analyticsEventFired.current = true;
		}
	}, [createAnalyticsEvent, bulkOpsFlow, attributes]);
};
